/**
 * Short-id helpers that gracefully handle both:
 *  - new short IDs (e.g. "AT-ABCDEF12", "JO-A1B2C3") — used as-is
 *  - legacy UUIDs                                    — truncated to 8 chars
 */
export function shortId(id) {
  if (!id) return "";
  // New short IDs already contain a dash near the start (e.g. "AT-...", "JO-...")
  if (id.length <= 12 && id.includes("-") && id.indexOf("-") <= 3) {
    return id;
  }
  return id.slice(0, 8);
}

export function attemptPdfFilename(attemptId) {
  if (!attemptId) return "IDDL-attempt.pdf";
  if (attemptId.startsWith("AT-")) {
    return `IDDL-${attemptId}.pdf`;
  }
  return `IDDL-attempt-${attemptId.slice(0, 8)}.pdf`;
}
